import { Mediator, app, payload, eData, EventData } from "modular-openscriptjs";
import {
	eParse,
	inform,
	processStart,
	processEnd,
} from "../helpers";
import { STRINGS, analytics, api, gc, uc, dc } from "../declarations";
import { routes } from "../backendRoutes";
import { analyze } from "../analytics";
import { trackStartPreparing } from "../reviewPrompt";

const $e = app("$e");

export class Order extends Mediator {
	$$order = {
		needs: {
			businessOrders: (ed, event) => {
				this.getBusinessOrders(ed, event);
			},
			markAsReady: (ed, event) => {
				this.markAsReady(ed, event);
			},
			markAsProcessing: (ed, event) => {
				this.markAsProcessing(ed, event);
			},
		},
	};

	async getBusinessOrders(ed, event) {
		const { message } = eParse(ed);
		
		const companyId = message.get("companyId");
		const filters = message.get("filters", {});

		let res = await api.get(routes.companyOrders(companyId), {
			...filters,
			page: message.get("page", 1),
			interval: message.get("interval", 15),
		});

		if (!res) return;

		this.broadcast($e.order.has.businessOrders, payload(res.data));
	}

	async markAsReady(ed, event) {
		const { message } = eParse(ed);
		const companyId = message.get("companyId");
		const orderId = message.get("orderId");
		const branchId = message.get("branchId");

		processStart({ title: "Updating order items" });

		let res = await api.put(routes.markOrderAsReady(companyId, orderId), {
			branch_id: branchId,
			organization: {
				id: companyId,
				type: "Company",
			}
		});

		processEnd();

		if (!res) return;

		inform(res.message, STRINGS.SUCCESS);
		this.broadcast($e.order.has.updatedStatus, ed);
	}

	async markAsProcessing(ed, event) {
		const { message } = eParse(ed);
		const companyId = message.get("companyId");
		const orderId = message.get("orderId");
		const branchId = message.get("branchId");

		processStart({ title: "Updating order items" });

		let res = await api.put(routes.markOrderAsProcessing(companyId, orderId), {
			branch_id: branchId,
			organization: {
				id: companyId,
				type: "Company",
			}
		});

		processEnd();

		if (!res) return;

		inform(res.message, STRINGS.SUCCESS);
		trackStartPreparing(orderId);
		this.broadcast($e.order.has.updatedStatus, ed);
	}
}
